import {useState} from 'react';
import {Box} from '@mui/material';
import './AnnotationList.scss';
import {t} from 'i18next';
import ManageHeader from '../components/manage-header/ManageHeader';
import {ISelectItem} from '../../shared/types';
import AnnotationListGrid from './annotation-list-grid/AnnotationListGrid';
const AnnotationList = () => {
  const [selectedGroup, setSelectedGroup] = useState<ISelectItem | null>(null);

  return (
    <Box className="annotation-view">
      <Box className="annotation-header">
        <ManageHeader
          title={t('annotationLayer.headerTitle')}
          infoContentTitle={t('annotationLayer.tooltipTitle')}
          infoContent={t('annotationLayer.tooltipContent')}
          onChangeGroup={setSelectedGroup}
        />
      </Box>
      <AnnotationListGrid selectedGroup={selectedGroup} />
    </Box>
  );
};

export default AnnotationList;
